import React from 'react';
export function CostComparison() {
  const data = [{
    sin: 'Sesiones sin estructura ni criterio claro',
    costo: 'Frustración y agotamiento constante'
  }, {
    sin: 'Sin sistema de planificación',
    costo: '3 horas perdidas cada domingo'
  }, {
    sin: 'Sin criterio para ARFID',
    costo: 'Casos mal manejados que desertan'
  }, {
    sin: 'Sin herramientas para la familia',
    costo: 'Avances que se borran cada lunes'
  }, {
    sin: 'Sin protocolos de progresión',
    costo: 'Estancamiento clínico mes a mes'
  }, {
    sin: 'Sentirte insegura con tus casos',
    costo: 'El costo profesional más alto de todos'
  }];
  return <section className="bg-cream py-16 px-4 border-t border-border" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-ink mb-10 font-serif" data-id="element-56">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-white rounded-3xl overflow-hidden border border-border shadow-md mb-10" data-id="element-57">
          <div className="grid grid-cols-2 bg-surface border-b border-border" data-id="element-58">
            <div className="p-6 text-center font-bold text-ink text-base md:text-lg" data-id="element-59">
              Sin Código Alimentario
            </div>
            <div className="p-6 text-center font-bold text-base md:text-lg text-urgency" data-id="element-60">
              Costo Real
            </div>
          </div>
          <div className="divide-y divide-border" data-id="element-61">
            {data.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-surface transition-colors" data-id="element-62">
                <div className="p-6 text-ink flex items-center justify-center text-center text-sm md:text-base font-medium" data-id="element-63">
                  {row.sin}
                </div>
                <div className="p-6 font-bold flex items-center justify-center text-center bg-urgency/5 text-urgency text-sm md:text-base" data-id="element-64">
                  {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-65">
          <p className="text-2xl md:text-4xl font-bold text-ink italic font-serif" data-id="element-66">
            La próxima sesión puede ser completamente diferente.
          </p>
        </div>
      </div>
    </section>;
}